<template>
	<div>
		<div class="datatable-paging" v-if="false && totalPages > 1">
			<a class="prev" :class="{'disabled': pageIndex == 1}" @click="prevPage"></a>
			<a v-for="(page, index) in (paginglist)" :key="index" @click="gotoPage(page)" :class="{'active': pageIndex == page}">{{ page }}</a>
			<a class="next" :class="{'disabled': pageIndex == totalPages}" @click="nextPage"></a>
		</div>

		<div class="datatable-tools">
			<form>
				<div>
					<div class="form-groups">
						<div class="form-group">
							<input type="text" v-on:keydown.enter.prevent="doSearch" placeholder="Indtast navn, e-mail, mobilnummer, ordrenummer eller transaktions ID" v-model="searchtext" />
						</div>
					</div>

					<div class="buttons-group">
						<button class="small text" @click.prevent="toggleAdvancedSearch">Avanceret</button>
						<button class="small text" @click.prevent="resetSearch">Nulstil</button>
						<button class="small" @click.prevent="doSearch">Søg</button>
					</div>
				</div>

				<transition name="fade">
					<div v-if="searchadvancedenabled">
						<div class="form-groups">
							<div class="form-group">
								<div class="input-group">
									<select v-model="searchstatus">
										<option value="0">Alle ordre</option>
										<option value="1">Kladde</option>
										<option value="2">Oprettet</option>
										<option value="5">Annulleret</option>
										<option value="6">Betalt</option>
										<option value="12">Betalt i shoppen</option>
										<option value="11">Betalt med betalingslink</option>
										<option value="9">Betalingslink sendt</option>
										<option value="10">Rykker sendt</option>
										<option value="7">Sendt til kunde</option>
										<option value="8">Refunderet</option>
									</select>
									<span></span>
								</div>
							</div>

							<div class="form-group">
								<VueCtkDateTimePicker v-model="searchdaterange"
													  :no-label="true"
													  :no-header="true"
													  :only-date="true"
													  :auto-close="true"
													  button-color="#000"
													  color="#000"
													  label="Dato"
													  :first-day-of-week="1"
													  :no-button-now="true"
													  :no-shortcuts="true"
													  :range="true" />
							</div>
						</div>
						<div class="form-groups">
							<div class="form-group">
								<div class="input-group">
									<select v-model="searchcustomerid" @change="searchCustomerChanged">
										<option selected="selected" value="0">Vælg institution</option>
										<option v-for="customer in customers" :key="customer.id" v-bind:value="customer.id">{{ customer.name }}</option>
									</select>
									<span></span>
								</div>
							</div>

							<div class="form-group" v-if="agreements && agreements.length > 1">
								<div class="input-group">
									<select v-model="searchagreementid" @change="loadData" :disabled="!searchcustomerid">
										<option value="0">Alle aftaler</option>
										<option v-for="agreement in agreements" :key="agreement.id" v-bind:value="agreement.id">{{ agreement.name }}</option>
									</select>
									<span></span>
								</div>
							</div>
						</div>
					</div>
				</transition>
			</form>
		</div>


		<table class="datatable">
			<thead v-if="!isMobile">
			<th class="sortable active left" @click="sort('name')">
				Person
			</th>
			<th>
				Ordre antal
			</th>
			<th>
				Betalt
			</th>
			<th class="sortable active" @click="sort('amount')">
				Total
			</th>
			<th class="sortable active" @click="sort('date')">
				Person/Ordre status
			</th>
			<th>
			</th>
			</thead>
			<tbody v-if="!isMobile">
				<template v-for="(person, index) in (data)">
					<template v-if="person == 'DELIMITER'">
						<tr class="delimiter" v-bind:key="index + '-delimiter'">
							<td colspan="6"></td>
						</tr>
					</template>
					<template v-else>
						<tr v-bind:key="person.id + '-' + person.persongroupid" :data-personid="person.id" :class="{ 'multipleorders': person.ordercount > 0 }">
							<td @click.prevent="handlePersonOrders(person, $event)">
								{{ person.name }}
								<div class="small" style="pointer-events: none;">
									{{ person.customername }}, {{ person.persongroupname }}
								</div>
							</td>
							<td @click.prevent="handlePersonOrders(person, $event)" class="center" v-if="person.ordercount == 1">
								{{ person.ordercount }} ordre
								<div class="small">#IM-SF-{{ person.firstorderid }}</div>
							</td>
							<td @click.prevent="handlePersonOrders(person, $event)" class="center" v-if="person.ordercount != 1">
								{{ person.ordercount }} ordrer
							</td>
							<td @click.prevent="handlePersonOrders(person, $event)" class="right nowrap">
								{{ getPayedPrice(person) }}
							</td>
							<td @click.prevent="handlePersonOrders(person, $event)" class="right nowrap">
								{{ getTotalPrice(person) }}
							</td>
							<td @click.prevent="handlePersonOrders(person, $event)" class="center" v-html="getPersonStatus(person)"></td>
							<td class="center" @click.prevent="addOrder(person)"><button class="small" style="padding: 0 8px; white-space: nowrap;">Ny ordre</button></td>
						</tr>
						<template v-for="(order) in (person.orders)">
							<tr @click="gotoOrder(order, person)" v-bind:key="person.id + '-' + person.persongroupid + '-' + order.id" class="multipleorderslist" :data-personid="person.id">
								<td>
									#{{ order.ordernumber }}<br />
									{{ getOrderInfo(order) }}
								</td>
								<td></td>
								<td class="right">
									{{ order.totalprice + getOrderReminderFee(order) }} kr.
								</td>
								<td></td>
								<td class="center" v-html="getOrderStatus(order)"></td>
								<td></td>
							</tr>
						</template>
					</template>
				</template>
			</tbody>
			<tbody v-else>
				<tr v-for="(person) in (data)" :key="person.id" @click="editOrder(person)">
					<td>
						<ul class="flex-content">
							<li data-label="Navn">{{ person.name }}</li>
							<li data-label="Ordre">{{ person.ordercount }} stk.</li>
							<li data-label="Betalt">{{ getPayedPrice(person) }}</li>
							<li data-label="Total">{{ getTotalPrice(person) }}</li>
							<li data-label="Status" v-html="getPersonStatus(person)"></li>
						</ul>
					</td>
				</tr>
			</tbody>
		</table>

		<div class="datatable-loadmore" v-if="pageIndex < totalPages">
			<div>Viser {{ actualShownOrders }} ud af {{ totalOrders }} ordre</div>
			<button class="loadmore outline small" @click="loadNextPage">Indlæs flere</button>
		</div>
		<div class="datatable-paging" v-if="false && totalPages > 1">
			<a class="prev" :class="{'disabled': pageIndex == 1}" @click="prevPage"></a>
			<a v-for="(page, index) in (paginglist)" :key="index" @click="gotoPage(page)" :class="{'active': pageIndex == page}">{{ page }}</a>
			<a class="next" :class="{'disabled': pageIndex == totalPages}" @click="nextPage"></a>
		</div>
		<div v-if="(data == null || data.length == 0) && !isComponentBusy">
			Ingen ordre fundet.
		</div>
		<transition name="fade">
			<div class="busyloader" v-if="isComponentBusy"><div><div></div><div></div><div></div><div></div></div></div>
		</transition>
	</div>
</template>

<script>
	import { types } from "@/app/types/types"
	import { orderStatusEnum } from "@/app/enums/common"
	import { orderPaymentStatusEnum, personStatusEnum } from "@/app/enums/common"
	import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
	import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

	export default {
		name: "PersonGroupShow",
		components:
		{
			VueCtkDateTimePicker
		},
		data: () => ({
			data: [],
			pageIndex: 1,
			pageSize: 30,
			currentSort: "date",
			currentSortDir: "desc",
			currentPage: 1,
			totalPages: 1,
			totalOrders: 0,
			actualShownOrders: 0,

			// Search options
			customers: [],
			agreements: [],
			searchadvancedenabled: false,
			searchtext: null,
			searchdaterange: null,
			searchcustomerid: 0,
			searchagreementid: 0,
			searchstatus: 0
		}),
		beforeRouteUpdate(to, from, next)
		{
			this.findOrders()
			next()
		},
		props: ["search", "findorderinput"],
		computed:
		{
			isMobile()
			{
				return this.$mq !== "tablethori" && this.$mq !== "desktop"
			},

			paginglist()
			{
				let pages = []

				for (let i = 1; i < (this.totalPages + 1); i++)
				{
					pages.push(i)
				}

				return pages
			}
		},
		mounted()
		{
			this.loadData()
			this.loadCustomers()
		},
		methods:
		{
			addOrder(person)
			{
				let url = this.$router.resolve({ name: "OrderEdit", params: { personid: person.id, persongroupid: person.persongroupid, orderid: 0, agreementid: person.agreementid, customerid: person.customerid } }).href
				window.open(url, url);
			},
			gotoOrder(order, person)
			{
				let url = this.$router.resolve({ name: "OrderEdit", params: { personid: person.id, persongroupid: person.persongroupid, orderid: order.id, agreementid: person.agreementid, customerid: person.customerid } }).href
				window.open(url, url);
			},
			handlePersonOrders(person, event)
			{
				if (person.ordercount > 1)
				{
					let tableRow = event.target.parentElement

					if (tableRow)
					{
						tableRow.classList.toggle("toggled")
						const showOrders = tableRow.classList.contains("toggled")

						let orderFound = true

						while (orderFound)
						{
							tableRow = tableRow.nextSibling

							if (tableRow && (tableRow.classList && tableRow.classList.contains("multipleorderslist")))
							{
								if (showOrders)
									tableRow.classList.add("toggled")
								else
									tableRow.classList.remove("toggled")
							}
							else
							{
								orderFound = false
								break
							}
						}
					}
				}
				else
				{
					let url = this.$router.resolve({ name: "OrderEdit", params: { personid: person.id, persongroupid: person.persongroupid, orderid: person.firstorderid, agreementid: person.agreementid, customerid: person.customerid } }).href
					window.open(url, url);
				}
			},
			getOrderReminderFee(order)
			{
				if (order.paymentreminder3lastsent && order.paymentreminder3fee && order.paymentreminder3fee > 0)
				{
					return order.paymentreminder3fee
				}
				else if (order.paymentreminder2lastsent && order.paymentreminder2fee && order.paymentreminder2fee > 0)
				{
					return order.paymentreminder2fee
				}
				else if (order.paymentreminder1lastsent && order.paymentreminder1lastsent > order.paymentlinklastsent)
				{
					return order.paymentreminder1fee
				}

				return 0
			},
			getPayedPrice(person)
			{
				var total = 0

				if (person.orders.length > 0)
				{
					person.orders.forEach(order =>
					{
						if (order.status == orderStatusEnum.COMPLETED)
						{
							total = total + order.totalprice + this.getOrderReminderFee(order)
						}
					})

					return total + " kr."
				}

				return ""
			},
			getTotalPrice(order)
			{
				if (order.ordercount > 0)
				{
					return order.ordersum + " kr."
				}

				return ""
			},
			doSearch()
			{
				if (this.searchtext && this.searchtext.length < 3)
				{
					alert("Indtast venligst en søge tekst på minimum 3 karakterer.")
					return
				}

				this.currentSort = "date"
				this.currentSortDir = "desc"
				this.pageIndex = 1
				this.loadData()
			},
			toggleAdvancedSearch()
			{
				this.searchadvancedenabled = !this.searchadvancedenabled
			},
			resetSearch()
			{
				this.searchtext = null
				this.searchadvancedenabled = false
				this.agreements = []
				this.searchadvancedenabled = false
				this.searchdaterange = null
				this.searchcustomerid = 0
				this.searchagreementid = 0
				this.searchstatus = ""

				this.pageIndex = 1
				this.searchstatus = 0
				this.currentSort = "date"
				this.currentSortDir = "desc"

				this.loadData()
			},
			searchCustomerChanged()
			{
				if (this.searchcustomerid && this.searchcustomerid != "")
				{
					this.loadAgreements(this.searchcustomerid)
				}
			},
			getOrderInfo(order)
			{
				if (order.status != orderStatusEnum.DRAFT)
				{
					var name = (order.ordername ? order.ordername + "<br />" : "")
					var email = (order.email ? order.email + "<br />" : "")
					var mobilenumber = (order.mobilenumber ? order.mobilenumber : "")
					return name + email + mobilenumber
				}
				else
				{
					return ""
				}
			},
			getOrderInfoOld(order)
			{
				if (order.status != orderStatusEnum.DRAFT)
				{
					var name = (order.ordername ? order.ordername + "<br />" : "")
					var email = (order.email ? order.email + "<br />" : "")
					var mobilenumber = (order.mobilenumber ? order.mobilenumber : "")
					return "<div class=\"nowrap\">" + order.ordernumber + "</div><div class=\"small faded\">" + name + email + mobilenumber + "</div>"
				}
				else
				{
					return ""
				}
			},
			getPersonInfo(order)
			{
				return "<div class=\"small faded\">" + order.persongroupname + ", " + order.customername + "</div>"
			},
			getOrderStatus(order)
			{
				let text = ""
				let status = ""
				let dateHtml = ""
				let orderchangeddate = ""

				if (order.orderstatuschangeddate)
				{
					orderchangeddate = order.orderstatuschangeddate ? new Date(order.orderstatuschangeddate) : null
				}
				else if (order.statuschangeddate)
				{
					orderchangeddate = order.statuschangeddate ? new Date(order.statuschangeddate) : null
				}

				var options = { year: "numeric", month: "long", day: "numeric", time: "numeric", hour: "2-digit", minute: "2-digit" }

				switch (order.status)
				{
					case orderStatusEnum.DRAFT:
						text = "Kladde"
						status = "draft"
						break
					case orderStatusEnum.READY:
						text = "Oprettet"
						status = "ready"

						if (order.paymentreminder3lastsent && order.paymentreminder3fee && order.paymentreminder3fee > 0)
						{
							text = "Rykker 3"
							status = "paymentreminder"
							let paymentReminder3LastSent = new Date(order.paymentreminder3lastsent)
							dateHtml = "Rykker 3 sendt<br />" + paymentReminder3LastSent.toLocaleTimeString("da-dk", options)
						}
						else if (order.paymentreminder2lastsent && order.paymentreminder2fee && order.paymentreminder2fee > 0)
						{
							text = "Rykker 2"
							status = "paymentreminder"
							let paymentReminder2LastSent = new Date(order.paymentreminder2lastsent)
							dateHtml = "Rykker 2 sendt<br />" + paymentReminder2LastSent.toLocaleTimeString("da-dk", options)
						}
						else if (order.paymentreminder1lastsent && order.paymentreminder1lastsent >= order.paymentlinklastsent)
						{
							text = "Rykker 1"
							status = "paymentreminder"
							let paymentReminder1LastSent = new Date(order.paymentreminder1lastsent)
							dateHtml = "Rykker 1 sendt<br />" + paymentReminder1LastSent.toLocaleTimeString("da-dk", options)
						}
						else if (order.paymentlinklastsent)
						{
							text = "Betalingslink"
							status = "ready"
							let paymentLinkLastSent = new Date(order.paymentlinklastsent)
							dateHtml = "Betalingslink sendt<br />" + paymentLinkLastSent.toLocaleTimeString("da-dk", options)
						}

						break
					case orderStatusEnum.COMPLETED:

						if (order.paymentstatus == orderPaymentStatusEnum.SUCCEEDED)
						{
							if (order.paymentlinklastsent)
							{
								text = "Betalingslink"
							}
							else
							{
								text = "Betalt"
							}

							status = "completed"
						}
						else if (order.paymentstatus == orderPaymentStatusEnum.FREE)
						{
							text = "Gratis"
							status = "completed"
						}
						else if (order.paymentstatus == orderPaymentStatusEnum.AWAITING)
						{
							text = "Gennemført, ikke betalt"
							status = "completed"
						}
						else if (order.paymentstatus == orderPaymentStatusEnum.REJECTED)
						{
							text = "Afvist"
							status = "cancelled"
						}

						if (orderchangeddate)
						{
							dateHtml = orderchangeddate.toLocaleDateString("da-dk", options)
						}

						break
					case orderStatusEnum.DELIVERED:
						text = "Sendt til kunde"
						status = "delivered"
						break
					case orderStatusEnum.REFUNDED:
						text = "Refunderet"
						status = "refunded"
						break
					default:
						text = "Ikke oprettet"
						status = "draft"
						break
				}

				return "<div class=\"orderstatus " + status + "\">" + text + "</div>" + (dateHtml ? "<div class=\"small\">" + dateHtml + "</div>" : "")
			},
			getPersonStatus(person)
			{
				if (person.orders && person.orders.length > 0)
				{
					var completedOrder = person.orders.find(o => o.status == orderStatusEnum.COMPLETED);

					if (completedOrder)
					{
						return this.getOrderStatus(completedOrder)
					}
					else
					{
						var firstOrder = person.orders[0];

						if (firstOrder)
						{
							if (firstOrder.paymentreminder3lastsent && firstOrder.paymentreminder3fee && firstOrder.paymentreminder3fee > 0)
							{
								return this.getOrderStatus(firstOrder)
							}
							else if (firstOrder.paymentreminder2lastsent && firstOrder.paymentreminder2fee && firstOrder.paymentreminder2fee > 0)
							{
								return this.getOrderStatus(firstOrder)
							}
							else if (firstOrder.paymentreminder1lastsent && firstOrder.paymentreminder1lastsent >= firstOrder.paymentlinklastsent)
							{
								return this.getOrderStatus(firstOrder)
							}
							else if (firstOrder.paymentlinklastsent)
							{
								return this.getOrderStatus(firstOrder)
							}
						}
					}
				}

				let text = ""
				let status = ""
				let dateHtml = ""
				let orderslastchangedate = person.orderslastchangedate ? new Date(person.orderslastchangedate) : null
				var options = { year: "numeric", month: "long", day: "numeric", time: "numeric", hour: "2-digit", minute: "2-digit" }

				switch (person.status)
				{
					case personStatusEnum.CREATED:
						text = "Kladde"
						status = "draft"
						break
					case personStatusEnum.READY:
						text = "Kan inviteres"
						status = "ready"
						break
					case personStatusEnum.READYCLIENTNOTIFIED:
						text = "Link sendt"
						status = "readyclientnotified"

						if (person.requestlinklastsent)
						{
							let date = new Date(person.requestlinklastsent)
							dateHtml = "Sendt " + date.toLocaleTimeString("da-dk", options)
						}

						break
					case personStatusEnum.CLIENTREQUESTEDRESHOOT:
						text = "Omfotografering"
						status = "clientrequestedreshoot"

						if (orderslastchangedate)
						{
							dateHtml = orderslastchangedate.toLocaleTimeString("da-dk", options)
						}

						break
					case personStatusEnum.CANCELLED:
						text = "Annulleret"
						status = "cancelled"

						if (orderslastchangedate)
						{
							dateHtml = orderslastchangedate.toLocaleTimeString("da-dk", options)
						}

						break
				}

				return "<div class=\"orderstatus " + status + "\">" + text + "</div>" + (dateHtml ? "<div class=\"small\">" + dateHtml + "</div>" : "")
			},
			getOrderDate(order)
			{
				if (order.orderid != 0)
				{
					var options = { year: "numeric", month: "long", day: "numeric", time: "numeric", hour: "2-digit", minute: "2-digit" }
					let date = new Date(order.statuschangeddate)
					return date.toLocaleTimeString("da-dk", options)
				}

				return ""
			},
			getFullname(person)
			{
				return person.information.firstname + " " + person.information.lastname
			},
			async loadData()
			{
				this.setAppAsBusy()
				let dateRange = "-"

				if (this.searchdaterange)
				{
					let startDate = new Date(this.searchdaterange.start)
					let endDate = new Date(this.searchdaterange.end)
					dateRange = startDate.getFullYear() + "-" + (startDate.getMonth() + 1) + "-" + startDate.getDate()
					dateRange += "," + endDate.getFullYear() + "-" + (endDate.getMonth() + 1) + "-" + endDate.getDate()
				}

				let sorttype = this.currentSort + this.currentSortDir

				await this.$store.dispatch(types.ACTION_GET_ORDERS, { pageindex: this.pageIndex, pagesize: this.pageSize, orderstatus: this.searchstatus, sorttype: sorttype, customerid: this.searchcustomerid, agreementid: this.searchagreementid, daterange: dateRange, searchtext: this.searchtext })
					.then(response =>
					{
						if (response.data && response.data.length > 0)
						{
							this.totalOrders = response.data[0].totalpersons
							this.totalPages = Math.round(this.totalOrders / this.pageSize)
							this.actualShownOrders = this.pageIndex * this.pageSize
						}

						if (this.data && this.data.length > 0 && this.pageIndex > 1)
						{
							this.data.push("DELIMITER")
							this.data = this.data.concat(response.data)
						}
						else
						{
							this.data = response.data
						}

						this.setAppAsIdle()
					})
					.catch(error =>
					{
						this.setAppAsIdle()
						logError("OrderList.loadData()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
					})
			},
			async loadCustomers()
			{
				this.setAppAsBusy()
				await this.$store.dispatch(types.ACTION_GET_CUSTOMERS)
					.then(response =>
					{
						if (response.data && response.data.length > 0)
						{
							this.customers = response.data
						}

						this.setAppAsIdle()
					})
					.catch(error =>
					{
						this.setAppAsIdle()
						logError("OrderList.loadCustomers()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
					})
			},
			async loadAgreements(customerid)
			{
				this.setAppAsBusy()
				let searchdata = { customerID: customerid, status: 0, period: 0 }
				await this.$store.dispatch(types.ACTION_GET_AGREEMENTS, searchdata)
					.then(response =>
					{
						if (response.data && response.data.length > 0)
						{
							this.agreements = response.data
						}

						this.setAppAsIdle()
					})
					.catch(error =>
					{
						this.setAppAsIdle()
						logError("OrderList.loadAgreements()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
					})
			},
			editOrder(order)
			{
				if (order != "DELIMITER")
				{
					let url = this.$router.resolve({ name: "OrderEdit", params: { agreementid: order.agreementid, customerid: order.customerid, personid: order.personid, persongroupid: order.persongroupid, orderid: order.orderid, isfind: "0", isfromorders: "1" } })
					window.open(url, url);
				}
			},
			sort: function (s)
			{
				if (s === this.currentSort)
				{
					this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc"
				}
				else if (s === "name")
				{
					this.currentSortDir = "asc"
				}
				else if (s === "date")
				{
					this.currentSortDir = "desc"
				}
				else if (s === "amount")
				{
					this.currentSortDir = "desc"
				}

				this.pageIndex = 1
				this.currentSort = s
				this.loadData()
			},
			loadNextPage()
			{
				this.pageIndex++
				this.loadData(true)
			},
			nextPage()
			{
				this.pageIndex++
				this.loadData()
			},
			prevPage()
			{
				this.pageIndex--
				this.loadData()
			},
			gotoPage(index)
			{
				this.pageIndex = index
				this.loadData()
			}
		}
	}
</script>
